const KeenSlider = window.KeenSlider
const { setInitialised, useAutoplay } = window.BAO.Carousel.plugins

class SectionCollabsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        mode: 'free',
        rubberband: false,
        slides: {
          perView: 'auto',
          spacing: 30,
        },
        defaultAnimation: {
          duration: 3000,
          easing: t => t,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 'auto',
              spacing: 80,
            },
          },
        },
        created: slider => this.updateSlideTabbing(slider),
        animationEnded: slider => this.updateSlideTabbing(slider),
        updated: slider => this.updateSlideTabbing(slider),
      },
      [
        setInitialised(),
        useAutoplay(0, { pauseOnHover: false, pauseOnFocus: true }),
      ],
    )
  }

  updateSlideTabbing (slider) {
    const details = slider?.track?.details
    if (!details) return

    const FULLY_VISIBLE = 0.99

    details.slides.forEach((slide, index) => {
      const link = slider.slides[index]?.querySelector('.util-FauxLink_Link')
      if (!link) return

      if (slide.portion >= FULLY_VISIBLE) {
        link.removeAttribute('tabindex')
      } else {
        link.setAttribute('tabindex', '-1')
      }
    })
  }
}

if (!customElements.get('section-collabs-carousel')) {
  customElements.define('section-collabs-carousel', SectionCollabsCarousel)
}
